import {
  useInertiaTitle
} from "./chunk-JWB7JTTF.mjs";

// src/vue3.ts
var vue3_default = {
  install(app) {
    useInertiaTitle();
  }
};
export {
  vue3_default as default
};
